import React, {Component} from 'react'
import * as Icon from '@ant-design/icons';
const IconFont = Icon.createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/c/font_4622761_2fo77tedtu6.js',
})

export default IconFont